// extracted by mini-css-extract-plugin
export var askAiIcon = "_pz-9";
export var container = "_pz-0";
export var groupSeparator = "_pz-a";
export var highlight = "_pz-4";
export var resultIcon = "_pz-5";
export var resultItem = "_pz-7";
export var resultSubtitle = "_pz-3";
export var resultTitle = "_pz-2";
export var resultsList = "_pz-1";
export var searchGroup = "_pz-6";
export var selected = "_pz-8";